// extracted by mini-css-extract-plugin
module.exports =  {"annotation-input":"Input-TY5b__annotation-input","form-actions":"Input-k72k__form-actions","save-path":"Input-JljQ__save-path","save-button":"Input-CYIp__save-button"};